/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function FindingContentGap({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M3 1.4A2.6 2.6 0 0 1 5.6 4v8A2.6 2.6 0 0 1 3 14.6H1a.6.6 0 1 1 0-1.2h2A1.4 1.4 0 0 0 4.4 12V4A1.4 1.4 0 0 0 3 2.6H1a.6.6 0 1 1 0-1.2zm12 0a.6.6 0 1 1 0 1.2h-2A1.4 1.4 0 0 0 11.6 4v8a1.4 1.4 0 0 0 1.4 1.4h2a.6.6 0 1 1 0 1.2h-2a2.6 2.6 0 0 1-2.6-2.6V4A2.6 2.6 0 0 1 13 1.4zm-6.9 9.7a.9.9 0 1 1 0 1.8.9.9 0 0 1 0-1.8m0-4a.9.9 0 1 1 0 1.8.9.9 0 0 1 0-1.8m0-4a.9.9 0 1 1 0 1.8.9.9 0 0 1 0-1.8" /></svg>;
}
;